import apiClient from './meta-client';
import type {
    ErrorWindow,
    ErrorSource,
    ErrorOverviewResponse,
    ErrorByPageResponse,
} from '@/types/errorAnalytics';

/** Resumo de erros por fonte (broadcast | esteira | flow) + quebra por código e por app. */
export const getErrorOverview = async (
    window: ErrorWindow,
    source: ErrorSource = 'broadcast',
): Promise<ErrorOverviewResponse> => {
    const response = await apiClient.get<ErrorOverviewResponse>(
        '/broadcast-errors/overview',
        { params: { window, source } },
    );
    return response.data;
};

/** Erros por página (paginado, filtro opcional por app e por código). */
export const getErrorsByPage = async (
    window: ErrorWindow,
    opts: {
        app_id?: number | null;
        error_code?: number | null;
        search?: string | null;
        sort_by?: string | null;
        sort_dir?: 'asc' | 'desc' | null;
        source?: ErrorSource;
        page?: number;
        per_page?: number;
    } = {},
): Promise<ErrorByPageResponse> => {
    const params: Record<string, string | number> = { window, source: opts.source ?? 'broadcast' };
    if (opts.app_id != null) params.app_id = opts.app_id;
    if (opts.error_code != null) params.error_code = opts.error_code;
    if (opts.search && opts.search.trim()) params.search = opts.search.trim();
    if (opts.sort_by) params.sort_by = opts.sort_by;
    if (opts.sort_dir) params.sort_dir = opts.sort_dir;
    params.page = opts.page ?? 1;
    params.per_page = opts.per_page ?? 25;

    const response = await apiClient.get<ErrorByPageResponse>(
        '/broadcast-errors/by-page',
        { params },
    );
    return response.data;
};
